exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "\nh1[data-v-18a4099e] {\n  font-size: 1.3rem;\n  margin-bottom: 1.8rem;\n}\n.hero.is-info[data-v-18a4099e] {\n  background-color: #ffffff;\n  color: #4a4a4a;\n}\n.hero .title[data-v-18a4099e] {\n  color: #4a4a4a;\n}\n", "", {"version":3,"sources":["/app/src/pages/Mip.vue"],"names":[],"mappings":";AACA;EACE,kBAAkB;EAClB,sBAAsB;CACvB;AACD;EACE,0BAA0B;EAC1B,eAAe;CAChB;AACD;EACE,eAAe;CAChB","file":"Mip.vue","sourcesContent":["\nh1[data-v-18a4099e] {\n  font-size: 1.3rem;\n  margin-bottom: 1.8rem;\n}\n.hero.is-info[data-v-18a4099e] {\n  background-color: #ffffff;\n  color: #4a4a4a;\n}\n.hero .title[data-v-18a4099e] {\n  color: #4a4a4a;\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-18a4099e","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/pages/Mip.vue
// module id = oqYX
// module chunks = 4